module.exports = __webpack_public_path__ + "img/home-1.e4b04e84.png";